export const ArticleAuditSummaryStatus = {
  ALL: 'all',
  EXCEPTION: 'exception',
  ERROR: 'error',
  RISKY: 'risky',
  NEEDS_REVISION: 'needs_revision',
  NEEDS_RESERVATION: 'needs_reservation',
  PUBLISH_NG: 'publish_ng',
  PUBLISH_OK: 'publish_ok',
  REQUIRES_REVISION: 'requires_revision',
  REQUIRES_CONSULTATION: 'requires_consultation',
}

export const ArticleAuditSummaryStatusText = {
  [ArticleAuditSummaryStatus.ALL]: '要対応（ALL）',
  [ArticleAuditSummaryStatus.EXCEPTION]: '対象外',
  [ArticleAuditSummaryStatus.ERROR]: 'エラー',
  [ArticleAuditSummaryStatus.RISKY]: 'リスクあり',
  [ArticleAuditSummaryStatus.NEEDS_REVISION]: '要修正',
  [ArticleAuditSummaryStatus.NEEDS_RESERVATION]: '要予約',
  [ArticleAuditSummaryStatus.PUBLISH_NG]: '公開NG',
  [ArticleAuditSummaryStatus.PUBLISH_OK]: '公開OK',
  [ArticleAuditSummaryStatus.REQUIRES_REVISION]: '修正依頼',
  [ArticleAuditSummaryStatus.REQUIRES_CONSULTATION]: '相談依頼',
}
